import { Field as ChakraField, FieldRootProps } from '@chakra-ui/react/field'
import { HStack } from '@chakra-ui/react/stack'
import * as React from 'react'

export type FieldProps = FieldRootProps & {
  label?: string
  htmlFor?: string
  optionalText?: string
  labelSize?: 'sm' | 'xs' | 'md'
  helperText?: React.ReactNode
  errorText?: React.ReactNode
  helperTextColor?: string
  actionSlot?: React.ReactNode
}

export const Field = React.forwardRef(function Field(props: FieldProps, ref: React.Ref<HTMLDivElement>) {
  const {
    label,
    children,
    htmlFor,
    helperText,
    errorText,
    optionalText,
    helperTextColor,
    actionSlot,
    labelSize = 'sm',
    ...rest
  } = props
  return (
    <ChakraField.Root ref={ref} {...rest}>
      {label && (
        <HStack>
          <ChakraField.Label htmlFor={htmlFor} css={{ whiteSpace: 'break-spaces' }} fontSize={labelSize}>
            {label}
            <ChakraField.RequiredIndicator fallback={optionalText} />
          </ChakraField.Label>
          {actionSlot}
        </HStack>
      )}
      {children}
      {helperText && (
        <ChakraField.HelperText {...(helperTextColor ? { color: helperTextColor } : {})}>
          {helperText}
        </ChakraField.HelperText>
      )}
      {errorText && <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>}
    </ChakraField.Root>
  )
})
